import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchBodySizes, createBodySize, deleteBodySize, updateBodySize } from '../../common/jsonstore';
import { BodySize } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';

export interface IAuthentication {
  BodySize: BodySize[];
  success: any;
  isProcessingComplete: boolean;
}


const initialState: IAuthentication = { BodySize: [], success: {}, isProcessingComplete: false };

const BodySizeSlice = createSlice({
  name: 'BodySizes',
  initialState,
  reducers: {
    receiveBodySizes: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        BodySize: action.payload,
        isProcessingComplete: false
      };
    },
    /*  receiveBodySizes(state, action: PayloadAction<BodySize[]>) {
       return action.payload;
     },
     receiveBodySize(state, action: PayloadAction<BodySize>) {
       state.push(action.payload);
     }, */
    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});

// export const { toggleBodySize } = BodySizeSlice.actions;

export const loadBodySizes = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const BodySizes = await fetchBodySizes().then((res: any) => {
      const groupedData = Object.values(res.reduce((acc: any, curr: any) => {
        if (!acc[curr.bodysize_value]) {
          acc[curr.bodysize_value] = {
            bodysize_value: curr.bodysize_value,
            nut: [curr.nut]
          };
        } else {
          acc[curr.bodysize_value].nut.push(curr.nut);
        }
        return acc;
      }, {}));
      dispatch(BodySizeSlice.actions.receiveBodySizes(groupedData))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body size not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addBodySize = (newBodySize: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await createBodySize(newBodySize).then((resp: any) => {
      dispatch(BodySizeSlice.actions.success({ 'sts': true, data: ['add', 'Body Size Created Successfully'] }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Size Not Created';
        dispatch(BodySizeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }

}

export const modifyBodySize = (newBodySize: BodySize, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await updateBodySize(newBodySize, id).then((resp: any) => {
      dispatch(BodySizeSlice.actions.success({ 'sts': true, data: ['update', 'Body Size Updated Successfully'] }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Size Not Updated';
        dispatch(BodySizeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeBodySize = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteBodySize(id).then((resp: any) => {
      dispatch(BodySizeSlice.actions.success({ 'sts': true, data: ['delete', 'Body Size Deleted Successfully'] }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Size Not Deleted';
        dispatch(BodySizeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(BodySizeSlice.actions.success(data));
}
export default BodySizeSlice.reducer;
